import { ScriptLoader } from '~/shared/utils/script-loader'
import { YandexMetricOptions } from '~/shared/utils/yandex-metric'

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const runtimeConfig = useRuntimeConfig()
  const isProd = runtimeConfig.public.environmentStand === 'prod'

  const { register } = useYandexMetric()

  const initMetric = () => {
    if (!router) return

    const config = {
      router,
      env: isProd ? 'production' : 'development',
      debug: !isProd,
    } as const

    register(
      new YandexMetricOptions({
        id: '88267674',
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: false,
      }).options,
      config,
    )
  }

  ScriptLoader.attach('https://mc.yandex.ru/metrika/tag.js')
    .then(initMetric)
    .catch((e) => {
      if (!ScriptLoader.isErrorLoader(e)) {
        throw e
      }
    })
})
